import {callSvg as Icon__small__callSvg} from '../Icon__small/Icon__small--call.js';

export var call = {
  name: 'call',
  category: 'icon',
  colorable: true,
  svg: Icon__small__callSvg,
};
